import React from 'react';

import AppSelect from '../../app-select/app-select';

interface PanelSelectProps {
  options: { value: string; label: string }[];
  onOptionSelect: (val: string) => void;
  selected?: string;
}

const PanelSelect: React.FC<PanelSelectProps> = ({
  options,
  selected,
  onOptionSelect,
}) => {
  const getSelected = () => options.find((item) => item.value === selected);

  return (
    <AppSelect
      sm
      value={getSelected()}
      options={options}
      isMulti={false}
      onChange={(val) => {
        if (val && !Array.isArray(val)) {
          onOptionSelect(val.value);
        }
      }}
    />
  );
};

export default PanelSelect;
